@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  @if (isLoaded) {
    <div class="configuration">
      <app-clm-product-line-header [isOem]="isOem()" [line]="entityLine()" (quantityChanged)="quantityChanged()"
        (tagInformationUpdated)="updateTaggingDetails($event)" [tags]="taggingDetails()">
      </app-clm-product-line-header>
      <app-console-sd-com-ratings (valueChanged)="validateUnit()" [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()">
      </app-console-sd-com-ratings>
      <app-console-sd-com-accessories [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-console-sd-com-accessories>
      <app-clm-performance-header-input [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()"
        [selectionEntities]="selectionEntities()" (valueChanged)="validateUnit()">
      </app-clm-performance-header-input>
      <app-clm-cooling-performance-input [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()"
        [selectionEntities]="selectionEntities()" (valueChanged)="validateUnit()">
      </app-clm-cooling-performance-input>
      <app-clm-heating-performance-input [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()"
        [selectionEntities]="selectionEntities()" (valueChanged)="validateUnit()">
      </app-clm-heating-performance-input>
      <app-clm-cooling-performance-output [results]="$safeNavigationMigration(performanceResponse()?.coolingData)"></app-clm-cooling-performance-output>
      <app-clm-heating-performance-output [results]="$safeNavigationMigration(performanceResponse()?.heatingData)"></app-clm-heating-performance-output>
    </div>
  }
  <div class="prices">
    <app-skus-and-prices [modelImagePath]="unitImagePath()" [messages]="messages" [skus]="skus()" [sfrEntries]="sfrEntries()"
      [entityLeadTime]="entityLeadTime"
      [configurationLeadTime]="configurationLeadTime()" (sfrFlagChanged)="sfrFlagChanged()">
    </app-skus-and-prices>
  </div>
</div>
